module.exports = __webpack_public_path__ + "img/8.8ae0a9f7.jpeg";